
import {
	Watch,
	SettingFilter, SettingService, EnumsFilter, EnumsService,
	 UserService, RoleService, BaseTLDetailComponent, AxiosResponse, UserRoleService, UserRoleFilter,
	tlISODateTimeToLocalNoSecondsString, LoginHistoryService, LoginHistoryFilter, RoleFilter, GroupFilter, GroupService, tlLogError
	} from "../../../Infrastructure/CorBase/CoreBase";
	import { logoutCurrentUser } from '../../../Infrastructure/Helpers/LoginLogoutHelper';


	export default abstract class UserDetailBase extends BaseTLDetailComponent {
		returnRoute: string = "UserList";
		userService: UserService = new UserService();
		userRoleService: UserRoleService = new UserRoleService();
		roleService: RoleService = new RoleService();
		groupService: GroupService = new GroupService();
		settingService: SettingService = new SettingService();
		enumService: EnumsService = new EnumsService();

		//pro michaele pouze
		typeState: any[] = [];
		items: any[] = [];


		idUser = 0;
		idRole = "2";
		activePage = '';
		alertModalTableId: string = 'modalSelectPerson';
		showModulePerson = false;
		minLengthPassword = 0;
		profile = false;
		isTeacher = false;

		showSelfRegistration = false;

		isChangePassword = false;

		authPassword = true;
		authGoogle = false;
		authFacebook = false;

		googleEmail = this.$t('user.messageGoogleInit').toString();

		isEditOwnUser = false; //jestli je to editace uzivatele, který je i vlastník	

		passwordNeed = false;
		passwordNeedGlobal = false;

		initMichael() {
			var enumsFilter = new EnumsFilter(null, 'ENU_COR_User_State');
			this.enumService.getAllByFilter(enumsFilter).then(res => {
				this.items = res.data;
				this.typeState = [];
				for (var i = 0; i < this.items.length; i++) {
					if (this.items[i].identifier == 'ENU_COR_User_State_Active' || this.items[i].identifier == 'ENU_COR_User_State_Blocked' ) {
						if (this.typeState.filter((c: any) => c.value == this.items[i].id).length == 0) {
							this.typeState.push({ value: this.items[i].id, text: this.items[i].name, description: this.items[i].name });
						}
					}
				}
					this.formData.idState = this.items[0].id;
			});
			if (this.$router.currentRoute.query.isTeacher) {
				this.formData.isTeacher = true;
				this.returnRoute = 'TeacherList';				
			}
		}

		formData = {			
			login: null,
			password: null,
			isSupperUser: false,
			creationDate: '',
			creationDatePrepare: '',
			loginLast: '',
			idStateNavigationName: null,
			selfRegistered:false,
			corUserRole: '',
			id: 0,
			idPerson: 0,
			idPersonNavigationFirstname: '',
			idPersonNavigationLastname: '',
			idTenant: this.$store.state.idTenant,
			idState: 1,
			idStateText: '',
			idUserRole: [] as number[],
			idGroup: 0,
			idPersonNavigationFullname: '',
			isDeleted: false,
			idEnumOauth: -1 as number,
			idEnumOauthName: '',
			idEnumOauthIdentif: '',
			email: '',
			isTeacher: false,
			class: [] as any[]
		};

		formDataPassword = {
			userId: this.objectId,
			isLoggedUserDetail: false,
			passwordOld: '',
			passwordNew: '',
			passwordNew2: ''
		};	

		isSelfRegistredUserBase() {
			return  this.$store.state.isSelfRegistrationUser;
		}



		showOauth(): boolean {		
			return String(this.$store.state.allowOAuth) == 'true';
		}

		getMinPassword() {
			let settingFilter: SettingFilter = new SettingFilter(null, false, false, false, null, null, 'SET_Password_Minimal_Length');
			this.settingService.getGlobalFilter(settingFilter).then((response) => {
				this.minLengthPassword = response.data as number;
			});
		}


		@Watch('formData.idEnumOauth')
		onPropertyIdTenant(value: string, oldValue: string) {
			if (value != oldValue) {
				//this.setTypeAutentization(this.stateText('idEnumOauth'));
				this.setTypeAutentization(this.formData.idEnumOauthIdentif);
				if (this.formIsInEditMode && this.authGoogle) {
					this.formData.password = null;
					this.formData.login = null;
				}
			}
		}

		setTypeAutentization(value: string) {
			if (value != '') {
				this.authPassword = value == 'ENU_COR_Oauth_Password';
				this.authGoogle = value == 'ENU_COR_Oauth_Google';
				this.authFacebook = value == 'ENU_COR_Oauth_Facebook';
			}
		}

		async googleLoginBase() {		
			try {			
				//@ts-ignore
				var googleUser = await this.$gAuth.signIn();
				//@ts-ignore
				var profile = googleUser.getBasicProfile();
				//@ts-ignore
				this.googleEmail = this.formData.login = profile.getEmail();

			}
			catch (error) {
				tlLogError('GoogleLoginBase',error);
			}

		}

		public cancelAction() {
			if (this.isChangePassword) {
				this.isChangePassword = false;
				this.formDataPassword.passwordOld = this.formDataPassword.passwordNew = this.formDataPassword.passwordNew2 = '';
			}
			else {
				//this.showAllertToCancelEditingClick();
				this.showAllertToCancelEditingWithSubClick();
			}
		}


		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
		}

		isActiveUser() {
			return !this.formData.isDeleted;
		}


		protected processResponse(response: AxiosResponse<any>): void {
			this.formData.id = response.data.id;
			this.formData.idPerson = response.data.idPerson;
			this.formData.email = response.data.email;
			this.formData.idState = response.data.idState;
			this.formData.isTeacher = response.data.isTeacher;
			this.formData.idStateText = response.data.idStateText;
			this.formData.selfRegistered = response.data.selfRegistered;
			this.googleEmail = this.formData.login = response.data.login;
			this.formData.password = response.data.password;
			this.formData.isSupperUser = response.data.isSupperUser;
			this.formData.creationDatePrepare = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
			this.formData.creationDate = response.data.creationDate;
			this.formData.idPersonNavigationFullname = response.data.idPersonNavigationFullname;
			this.formData.isDeleted = response.data.isDeleted;
			this.formData.idGroup = response.data.idGroup;
			if (response.data.lastLoginDate === null) {
				this.formData.loginLast = '';
			} else {
				this.formData.loginLast = tlISODateTimeToLocalNoSecondsString(response.data.lastLoginDate);//new Date(response.data.lastLoginDate).toLocaleDateString() + '  ' + new Date(response.data.lastLoginDate).toLocaleTimeString();
			}
			this.formData.idStateNavigationName = response.data.idStateNavigationName;
			this.formData.corUserRole = response.data.roleIdentifierList;
			this.formData.idEnumOauth = response.data.idEnumOauth;
			this.formData.idEnumOauthName = response.data.idEnumOauthName;
			this.setTypeAutentization(response.data.idEnumOauthIdentif);
			this.isEditOwnUser = this.formData.id === this.$store.state.idUser;
			this.formData.idPersonNavigationFirstname = response.data.idPersonNavigationFirstname;
			this.formData.idPersonNavigationLastname = response.data.idPersonNavigationLastname;
			this.loadDataRole(this.formData.id, false);

			this.formData.idEnumOauthIdentif = response.data.idEnumOauthIdentif;
			this.formData.class = response.data.class;
			if (this.$router.currentRoute.query.isTeacher || this.$store.state.isTeacher==true) {
				this.initAllClasses();
				this.classAll = this.formData.class;
				this.classOld = [];
				this.classAll.forEach(val => this.classOld.push(Object.assign({}, val)));
			}
			
		}

		protected afterCreate(response: AxiosResponse<any>): void {
			this.formDataPassword.userId	= this.formData.id = response.data.id;
			this.idUser = response.data.id;
	
			this.formData.idPerson = response.data.idPerson;
			this.formData.idPersonNavigationFirstname = response.data.idPersonNavigationFirstname;
			this.formData.idPersonNavigationLastname = response.data.idPersonNavigationLastname;
			this.formData.email = response.data.email;
			this.formData.idStateText = response.data.idStateText;
			this.formData.idState = response.data.idState;
			this.formData.idEnumOauthName = response.data.idEnumOauthName;
			this.formData.idEnumOauth = response.data.idEnumOauth;
			this.formData.creationDatePrepare = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
			this.loadDataRole(this.formData.id, false);
		}


		protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
			return this.userService.getById(this.objectId);
		}

		doAction() {
			if (this.styleFormNew) {
				this.createUser();
			}

			else {
				if (this.formIsInEditMode || this.styleFormDelete) {
					super.doCRUDActionWithInfoMessage(this.$t('user.messageNew').toString(), this.$t('user.messageEdit').toString(), this.$t('user.messageDelete').toString());					
				}
				

				if (!this.roleNotChangeBase()) {
					this.saveChangeRoleBase();
				}
				if (!this.classNotChangeBase()) {
					this.saveChangeUserClassBase();
				}
			}
		}

		private stateText(name:string): string {
			var e = (document.getElementById(name)) as HTMLSelectElement;
		
			if (e == null)
				return '';
			if (e.selectedOptions[0] == undefined) {
				return '';
			}
			return e.selectedOptions[0].innerText;
		}

		protected updateObject(): Promise<AxiosResponse<any>> {
			//(this.$refs.addRoles as AddRoleList).saveChanges();
			this.formData.idStateText = this.stateText('idState');
			this.formData.idEnumOauthName = this.stateText('idEnumOauth');
	
			return this.userService.update(this.idUser, this.formData);
		}

		protected createObject(): Promise<AxiosResponse<any>> {
			this.formData.idUserRole = [];
			var oDate = new Date();
			this.formData.creationDate = oDate.toJSON();
			
			return this.userService.create(this.formData);
		}

		protected deleteObject(): Promise<AxiosResponse<any>> {
			// pokus smazeme aktualne prihlasene uzivatele, tak musi dojit k odhlaseni
			if (this.formData.id === this.$store.state.idUser) {
				logoutCurrentUser();
			}
			return this.userService.delete(this.objectId);
		}

		protected isOwner(): boolean {
			return this.idUser == this.$store.state.idUser;
		}

		isExistUser() {
			return this.idUser > 0;
		}

		selectPerson() {
			this.showModal(this.alertModalTableId);
		}

		protected deleteRoleBase(item: any): void {
			this.idRole = item.idRole;
			this.rolesAll = (this.rolesAll).filter(d => d.id != item) as [];
		}

		protected addNewRoleBase(): void {		
			this.initAllRoles();
			this.$bvModal.show('roleModal');
		}

		//přechod na
		detailPerson() {
			this.$router.push({ name: "PersonDetail", params: { id: this.formData.idPerson.toString() , goBack: "user"} });
		}

		deletePerson() {
			this.formData.idPerson = 0;
			this.formData.idPersonNavigationFullname = '';
		}

		selectItem(select: any) {
			this.formData.idPerson = Number(select.id);
			this.formData.idPersonNavigationFullname = select.firstName + ' ' + select.lastName;
		}

		showSaveButtonChild(isNormalSave: boolean) {
			return this.isExistUser() == isNormalSave && this.showSaveButton;
		}

		createdBase() {
			this.mainDataChanged = false;
				if (this.formDataPassword.userId === this.$store.state.idUser) {
					this.formDataPassword.isLoggedUserDetail = true;
			}
			if (this.$router.currentRoute.params.profile) {
				this.profile = true;
			}
		
			this.showSelfRegistration = this.$store.state.selfRegistration;
			this.getMinPassword();

			//TODO at je to pouze u michaelu
			this.initMichael();
			if (this.$router.currentRoute.query.isTeacher) {
				this.isTeacher = true;
			}
		}

		createUser(): boolean {
			
			if (this.styleFormNew) {
				var oDate = new Date();
				this.formData.idUserRole = [];
				this.formData.creationDate = oDate.toJSON();
				this.userService.create(this.formData).then((response) => {
					if (response.data.isSuccess == false) {
						this.showAlertModalWithTitleAndContent('Chyba', JSON.stringify(response.data.errorMessage));
					}
					if (this.isExistUser()) {
						this.isSuccessfully = true;
						this.showAlertModalWithTitleAndContent(this.$t('global.titleInfo').toString(), this.$t('user.messageEdit').toString());
					}
					else {
						this.isSuccessfully = false;
						if (Number(response.data.id) == 0) {
							this.showAlertModalWithTitleAndContent(this.$t('global.titleInfo').toString(), this.$t('user.messageLogin').toString());
						}
						else {
							this.formData.idState = response.data.idState;
							this.formData.creationDatePrepare = tlISODateTimeToLocalNoSecondsString(response.data.creationDate);
							this.idUser = Number(response.data.id);
							this.formData.idStateText = response.data.idStateText;
							this.styleFormDetail = true;
							this.styleFormNew = false;
							var message = this.isTeacher ? this.$t('teacher.new').toString() : this.$t('user.messageNew').toString();
							this.afterCreate(response);
							//nacteni roli jen kdyz je ucitel
							if (this.isTeacher) {
								this.loadDataRole(this.idUser, false);
								this.isTeacher = this.formData.isTeacher = true;
							}
						

							//vlastni uprava url
							this.afterCreateChangeUrlOwn(response.data.id, this.isTeacher.toString());
							this.formIsInEditMode = false;
							this.showAlertModalWithTitleAndContent(this.$t('global.titleInfo').toString(), message);
						}
					}
				}).catch((error) => {

					this.isSuccessfully = false;
					this.showAlertModalWithTitleAndContent('Chyba', JSON.stringify(error.data.errors));
				});
			}

			return this.isSuccessfully;
		}

		public afterCreateChangeUrlOwn(id: string, isTeacher: string) {
			if (this.allowChangeUrlAfterCreate) {
				var namePage = String(this.$router.currentRoute.name);
				const newQuery: { id?: string; isTeacher?: string } = {}; 
				//@ts-ignore
				newQuery['id'] = id;
				if (isTeacher == 'true') {
					//@ts-ignore
					newQuery['isTeacher'] = isTeacher;
					this.isTeacher = true;

				}
				this.$store.commit("mainDataChanged", false);
				this.$store.commit("formIsInEditMode", false);

				this.$router.replace({ name: namePage, query: newQuery });
			}
		}

		saveAndContinue() {
			this.createUser();
		}

		changePassword() {
			this.$router.push({ name: "PasswordChange", params: { id: this.$router.currentRoute.params.id, type: "newPassword" } });
		};

		vLogin: boolean = true;
		vPassword: boolean = true;
		vPasswordAgain: boolean = true;
			
		
		fieldsRole = [
			//	{ key: 'id', label: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' },
			//{ key: 'idRoleNavigationIdentifier', label: 'Identifikátor', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'idRoleNavigationName', label: this.$t('user.fieldName'), trans: 'user.fieldName', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'idRoleNavigationDescription', label: this.$t('user.fieldDescription'), trans: 'user.fieldDescription', sortDirection: 'asc', sortable: true, class: 'text-center' },
			{ key: 'actions', label: '', class: 'text-right' }
		];

		protected selectItems: any[] = []; //vyber vice prvku	
		isEditReceiverDetail = true;


		public showPasswordButton(): boolean {
			return true;
		}

		protected goToChangePassword(): void {
			this.isChangePassword = true;
		}
		
		protected savePasswordChange(): void {
			this.userService.updatePassword(this.formDataPassword.userId, this.formDataPassword).then((response) => {
				this.isSuccessfully = true;
				this.showAlertModalWithTitleAndContent(this.$t('global.titleInfo').toString(), this.$t('user.messagePasswordChange').toString());
				this.cancelAction();
			}).catch((error) => {				
				this.isSuccessfully = false;
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), JSON.stringify(error.data.errors));
			});
		}


		//ulozeni roli, pripadne i trid
		protected saveChangeRoleBase(): void {
			

			if (!this.roleNotChangeBase()) {
				this.isBusy = true;
				this.changeData = [];
				for (var i = 0; i < this.rolesAll.length; i++) {
					if (this.rolesOld.filter(c => c.idRole == this.rolesAll[i].idRole && c.idUser == this.rolesAll[i].idUser).length == 0) {
						this.changeData.push(this.dataS(true, this.rolesAll[i].idRole, this.formData.id, this.formData.idGroup, true, this.$store.state.idTenant));
					}
				}
				for (var i = 0; i < this.rolesOld.length; i++) {
					if (this.rolesAll.filter(c => c.idRole == this.rolesOld[i].idRole && c.idUser == this.rolesOld[i].idUser).length == 0) {
						this.changeData.push(this.dataS(false, this.rolesOld[i].idRole, this.formData.id, 0, true, this.$store.state.idTenant));
					}
				}

				this.userRoleService.create(this.changeData).then(() => {
					this.isSuccessfully = true;
					this.isBusy = false;
					this.rolesOld = [];
					this.rolesAll.forEach(val => this.rolesOld.push(Object.assign({}, val)));
				}).catch((error) => {
					this.isSuccessfully = false;
					this.showAlertModalWithTitleAndContent('Chyba ', JSON.stringify(error.response.data.errors));
					this.isBusy = false;
				});
			}

		}

		saveRoleAndClasses() {
			if (!this.roleNotChangeBase()) {
				this.saveChangeRoleBase();
			}
			if (!this.classNotChangeBase()) {
				this.saveChangeUserClassBase();
			}
		}

		protected saveChangeUserClassBase(): void {
			this.isBusy = true;
			this.userService.userEnums(this.idUser, this.classAll).then(res => {
				this.classAll = res.data;
				this.classOld = [];
				this.classAll.forEach(val => this.classOld.push(Object.assign({}, val)));
				this.isBusy = false;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageSaveUserClass').toString());
				this.isBusy = false;
			});
		}

		protected goBackRolesBase(): void {
			this.rolesAll = [];
			this.rolesOld.forEach(val => this.rolesAll.push(Object.assign({}, val)));
		}

		public roleNotChangeBase(): boolean {
			if (this.rolesAll.length != this.rolesOld.length) {
				return false;
			}
			else {
				for (var i = 0; i < this.rolesAll.length; i++) {
					if (this.rolesOld.filter(c => c.id == this.rolesAll[i].id).length == 0) {
						return false;
					}
				}
			}
			return true;
		}

		dataS(selected: boolean, role: number, user: number, group: number, forAll: boolean, idTenant: number) {
			return {
				isSelected: selected,
				idRole: role,
				idUser: user,
				idGroup: group,
				forAll: forAll,
				idTenant: idTenant
			}
		}

		changeData: {
			isSelected: boolean,
			idRole: number,
			idUser: number,
			idGroup: number,
			forAll: boolean,
			idTenant: number
		}[] = [];


		loadDataRole(userId: number | null, fromOtherUser: boolean) {
			if (userId) {
				this.userRoleService.getAllByFilter(new UserRoleFilter(userId, null, this.$store.state.idTenant)).then((responsed) => {
					if (responsed.data.length == 1 &&  responsed.data[0].isSuccess == false) {
						this.showAlertModalWithTitleAndContent('Chyba', responsed.data[0].errorMessage);
                    }
					//TODO docasne
					this.formData.idGroup = responsed.data[0].idGroup;
					this.rolesAll = [];
					for (var i = 0; i < responsed.data.length; i++) {
						if (responsed.data[i].isSelected || responsed.data[i].partlySelected) {
							this.rolesAll.push(responsed.data[i]);
						}
					}
					this.rolesOld = [];
					this.rolesAll.forEach(val => this.rolesOld.push(Object.assign({}, val)));
				});
			}
		}

		protected selectedRoleItemsBase(selected: any): void {
			for (var i = 0; i < selected.length; i++) {
				var item = this.rolesModal.filter(c => c.id == selected[i])[0];
				this.rolesAll.push({ id: item.id, idRoleNavigationName: item.name, idRole: item.id, idRoleNavigationDescription: item.description, idRoleNavigationIdentifier: item.identifier });
			}
		}

		isCorrectLoginBase(value: any) {
			this.vLogin = value ;
		}
		isCorrectPassBase(value: any) {
			this.vPassword = value || !this.authPassword;
		}
		isCorrectPassAgainBase(value: any) {
			this.vPasswordAgain = value || !this.authPassword;
		}

		vPasswordOld: boolean = true;
		vPasswordNew: boolean = true;
		vPasswordNew2: boolean = true;
		vEmail: boolean = true;
		vIsCorrectName: boolean = true;
		vIsCorrectLastName: boolean = true;

		isCorrectPassOldBase(value: any) {
			this.vPasswordOld = value || !this.formDataPassword.isLoggedUserDetail;
		}
		isCorrectPassNewBse(value: any) {
			this.vPasswordNew = value;
		}
		isCorrectPassNewBase2(value: any) {
			this.vPasswordNew2 = value;
		}
		isCorrectEmailBase(value: any) {
			this.vEmail = value == false || this.formData.email == "";
		}

		isCorrectNameBase(value: any) {
			this.vIsCorrectName = value;
		}

		isCorrectLastNameBase(value: any) {
			this.vIsCorrectLastName = value;
		}

		validatePassword() {
			
			return !(this.vPasswordOld && this.vPasswordNew && this.vPasswordNew2 );
		}

		protected changeFieldsAfterChangeLanguageBase(value: boolean, oldValue: boolean) {
			if (value !== oldValue) {
				this.fieldsHistoryModal = this.changeTranslate(this.fieldsHistoryModal);
				this.filtersHistoryModal = this.changeTranslate(this.filtersHistoryModal);
				this.fieldsRoleModal = this.changeTranslate(this.fieldsRoleModal);
				this.filtersRoleModal = this.changeTranslate(this.filtersRoleModal);

				//this.fetchData();
				this.loadDataRole(this.formData.id, false);
				
			}
		}

		emailNotCorrect() {
			return this.vEmail == false ;
		}
		validate() {					
			var result = !(this.vLogin && this.vPassword && this.vPasswordAgain && this.vPasswordAgain && (this.emailNotCorrect() || this.styleFormNew)		);
			return result;
		}

		validateMichael() {
			var result = !(this.vLogin && this.vPassword && this.vPasswordAgain && this.vPasswordAgain && (this.formData.isTeacher == false || (this.vIsCorrectName && this.vIsCorrectLastName)) );
			return result;
		}
	
		private showHistoryModal(): void {
			this.initHistory();
			this.$bvModal.show('historyModal');
		}

		historyAll: [] = [];
		loginHistoryService: LoginHistoryService = new LoginHistoryService();

		fieldsHistoryModal = [
			{ key: 'loginDate', label: this.$t('loginHistoryList.fieldDate'), trans: 'loginHistoryList.fieldDate', sortable: true, sortDirection: 'asc', class: 'text-center', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
			{ key: 'idStateNavigationName', label: this.$t('loginHistoryList.fieldState'), trans: 'loginHistoryList.fieldState', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'ipaddressText', label: this.$t('loginHistoryList.fieldIP'), trans: 'loginHistoryList.fieldIP', sortable: true, sortDirection: 'asc', class: 'text-center' }
		];

		filtersHistoryModal = [
			{ key: 'ipaddressText', label: this.$t('loginHistoryList.filterIP'), trans: 'loginHistoryList.filterIP', selected: false, value: null, type: 'text' }
		];

		

		modalNameHistory(): string {
			return this.$t('user.modalHistory').toString();// + ' ' + this.formData.login;
		}

		modalNameRole(): string {
			return this.$t('user.modalRole').toString();// + ' ' + this.formData.login;
		}

		protected initHistory(): void {
			this.isBusy = true;
			let loginFilter: LoginHistoryFilter = new LoginHistoryFilter(this.idUser);
			this.loginHistoryService.getAllByFilter(loginFilter).then(response => {
				this.historyAll = response.data;
				this.isBusy = false;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageInitHistory').toString());
				this.isBusy = false;
			});
		}

		private goToSettignUser(): void {			
			this.$router.push({ name: 'SettingUserList', query: { userId: this.idUser.toString(), goBack: "UserDetail"}});
		}

		rolesAll: any[] = [];
		rolesOld: any[] = [];
		rolesModal: any[] = [];

		classAll: any[] = [];
		classOld: any[] = [];
		classModal: any[] = [];
		classModalBefore: any[] = [];

		protected initAllRoles(): void {
			this.isBusy = true;
			let roleFilter: RoleFilter = new RoleFilter(null, null, this.$store.state.idTenant);
			this.roleService.getAllByFilter(roleFilter).then(res => {			
				var result = [];
				for (var i = 0; i < res.data.length; i++) {
					this.rolesModal = [];
					if (this.rolesAll.filter(c => c.id == res.data[i].id).length == 0) {
						result.push(res.data[i]);
					}
				}
				
				this.rolesModal = result;
				this.isBusy = false;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageInitRole').toString());
				this.isBusy = false;
			});
		}

		fieldsRoleModal = [
			//{ key: 'identifier', label: this.$t('role.fieldIdentif'), trans: 'role.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', sortable: true, class: 'text-center' }
		];

		filtersRoleModal = [
			{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', selected: true, value: null, type: 'text', isEditable: true, showOnlyClean: true }
		];
	

		userRolesModal: any[] = [];

		protected settingRoleBase(item: any): any {			
			this.$bvModal.show('userRoleModal');
			return this.initAllUserRoles(item);
		}

		protected initAllUserRoles(item: any): any {
			this.isBusy = true;
			this.idRole = item.id;
			let groupFilter: GroupFilter = new GroupFilter(Number(this.idUser), Number(item.id), this.$store.state.idTenant, 'ROLE');

			return this.groupService.getAllByFilter(groupFilter).then(res => {
				this.userRolesModal = res.data;
				this.isBusy = false;
				return res.data;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageUserRole').toString());
				this.isBusy = false;
			});
		}

		//ulozeni změn
		public changeDataBase(changeData: any): void {

			this.userRoleService.create(changeData).then(() => {
				this.isSuccessfully = true;
			}).catch((error) => {
				this.isSuccessfully = false;
				this.showAlertModalWithTitleAndContent('Chyba ', JSON.stringify(error.response.data.errors));
			});
		}

		modalNameUserRole(): string {
			return this.$t('user.modalUserRole').toString() + ' ' + this.formData.login;
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}

		fieldsClass = [
				//{ key: 'id', label: 'id', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'name', label: this.$t('user.fieldClassName'), trans: 'user.fieldClassName', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'description', label: this.$t('user.fieldClassDescription'), trans: 'user.fieldClassDescription', sortable: true, sortDirection: 'asc', class: 'text-center' },
			{ key: 'actions', label: '', class: 'text-right' }
		];

		fieldsClassModal = [
			{ key: 'text', label: this.$t('role.fieldName'), trans: 'role.fieldName', sortable: true, class: 'text-center'  ,sortDirection: 'asc', },
			{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', sortable: true, class: 'text-center' }
		];

		filtersClassModal = [
			{ key: 'text', label: this.$t('role.fieldName'), trans: 'role.fieldName', selected: false, value: null, type: 'text', isEditable: true }
		];

        protected initAllClasses(): void {
            this.isBusy = true;
            var enumsFilter = new EnumsFilter(null, 'ENU_STU_Student_Class',false);
            this.enumService.getAllByFilter(enumsFilter).then(res => {
                this.items = res.data;           
                this.classModal = [];
                for (var i = 0; i < this.items.length; i++) {
					if (this.classAll.filter((c: any) => c.id == this.items[i].id).length == 0) {
						this.classModalBefore.push(this.items[i]);
						this.classModal.push({ id: this.items[i].id, identifier: 'TEST', name: this.items[i].name, value: this.items[i].name, text: this.items[i].name, description: this.items[i].description });
                    }
                }
                this.isBusy = false;
			}).catch(error => {
				this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageActivateClass').toString());
				this.isBusy = false;
			});

		}

		selectedClassItemsBase(selected: any) {
			for (var i = 0; i < selected.length; i++) {
				var item = this.classModalBefore.filter(c => c.id == selected[i])[0];
				this.classAll.push(item);
			}
		}

		protected addNewClassBase(): void {
			this.initAllClasses();
			this.$bvModal.show('classModal');
		}


		protected goBackClassBase(): void {
			this.classAll = [];
			this.classOld.forEach(val => this.classAll.push(Object.assign({}, val)));
		}

		public classNotChangeBase(): boolean {
			if (this.classAll.length != this.classOld.length) {
				return false;
			}
			else {
				for (var i = 0; i < this.classAll.length; i++) {
					if (this.classOld.filter(c => c.id == this.classAll[i].id).length == 0) {
						return false;
					}
				}
			}
			return true;
		}

		deleteClassBase(item: any) {
			this.classAll = (this.classAll).filter(d => d.id != item) as [];
		}

	}

